export default __webpack_public_path__ + "assets/icons/circle.f2137e4e.svg";